import { createJSONStorage } from "jotai/utils";

export const jotaiSessionStorage = createJSONStorage<unknown>(
  () => sessionStorage,
);

export const jotaiLocalStorage = createJSONStorage<unknown>(() => localStorage);
